export const TIME_SCALES = [25, 50];